import {
  KeenIcon,
  MenuArrow,
  MenuIcon,
  MenuItem,
  MenuLink,
  MenuSeparator,
  MenuSub,
  MenuTitle,
} from '@/components';
import { useLanguage } from '@/i18n';

const DropdownCard1 = () => {
  const { isRTL } = useLanguage();

  return (
    <MenuSub className="menu-default" rootClassName="w-full max-w-[200px]">
      <MenuItem>
        <MenuLink
          path="/account/activity"
          className="contrast:text-white contrast:hover:bg-gray-700"
        >
          <MenuIcon className="contrast:text-white contrast:hover:text-white">
            <KeenIcon icon="cloud-change" />
          </MenuIcon>
          <MenuTitle className="contrast:text-white">Activity</MenuTitle>
        </MenuLink>
      </MenuItem>
      <MenuItem>
        <MenuLink
          path="#"
          className="contrast:text-white contrast:hover:bg-gray-700"
        >
          <MenuIcon className="contrast:text-white contrast:hover:text-white">
            <KeenIcon
              icon="share"
              className="contrast:text-white contrast:hover:text-white"
            />
          </MenuIcon>
          <MenuTitle className="contrast:text-white">Share</MenuTitle>
        </MenuLink>
      </MenuItem>
      <MenuItem
        toggle="dropdown"
        trigger="hover"
        dropdownProps={{
          placement: isRTL() ? 'left-start' : 'right-start',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: isRTL() ? [15, 0] : [-15, 0], // [skid, distance]
              },
            },
          ],
        }}
      >
        <MenuLink className="contrast:text-white contrast:hover:bg-gray-700">
          <MenuIcon className="contrast:text-white contrast:hover:text-white">
            <KeenIcon icon="notification-status" />
          </MenuIcon>
          <MenuTitle className="contrast:text-white">Notifications</MenuTitle>
          <MenuArrow className="contrast:text-white">
            <KeenIcon
              icon="right"
              className="text-3xs rtl:transform rtl:rotate-180"
            />
          </MenuArrow>
        </MenuLink>
        <MenuSub className="menu-default" rootClassName="w-full max-w-[175px]">
          <MenuItem>
            <MenuLink
              path="/account/home/settings-sidebar"
              className="contrast:text-white contrast:hover:bg-gray-700"
            >
              <MenuIcon className="contrast:text-white contrast:hover:text-white">
                <KeenIcon icon="sms" />
              </MenuIcon>
              <MenuTitle className="contrast:text-white">Email</MenuTitle>
            </MenuLink>
          </MenuItem>
          <MenuItem>
            <MenuLink
              path="/account/home/settings-sidebar"
              className="contrast:text-white contrast:hover:bg-gray-700"
            >
              <MenuIcon className="contrast:text-white contrast:hover:text-white">
                <KeenIcon icon="message-notify" />
              </MenuIcon>
              <MenuTitle className="contrast:text-white">SMS</MenuTitle>
            </MenuLink>
          </MenuItem>
          <MenuItem>
            <MenuLink
              path="/account/home/settings-sidebar"
              className="contrast:text-white contrast:hover:bg-gray-700"
            >
              <MenuIcon className="contrast:text-white contrast:hover:text-white">
                <KeenIcon icon="pencil" />
              </MenuIcon>
              <MenuTitle className="contrast:text-white">Push</MenuTitle>
            </MenuLink>
          </MenuItem>
        </MenuSub>
      </MenuItem>
      <MenuItem>
        <MenuLink
          path="#"
          className="contrast:text-white contrast:hover:bg-gray-700"
        >
          <MenuIcon className="contrast:text-white contrast:hover:text-white">
            <KeenIcon icon="dislike" />
          </MenuIcon>
          <MenuTitle className="contrast:text-white">Report</MenuTitle>
        </MenuLink>
      </MenuItem>
      <MenuSeparator />
      <MenuItem>
        <MenuLink
          path="/account/home/settings-enterprise"
          className="contrast:text-white contrast:hover:bg-gray-700"
        >
          <MenuIcon className="contrast:text-white contrast:hover:text-white">
            <KeenIcon icon="setting-3" />
          </MenuIcon>
          <MenuTitle className="contrast:text-white">Settings</MenuTitle>
        </MenuLink>
      </MenuItem>
    </MenuSub>
  );
};

export { DropdownCard1 };
